<template lang="pug">
#transactions_page
  div(v-if="$store.getters.transactions_past_not_entered.length > 0" style='padding-bottom: 0.5em')
    .has-text-centered(v-if='HM.is_mobile')
      a.button.is-info.is_small(@click='viewPastNotEntered()') {{ $t('past_unconfirmed') }}
    .message.is-info(v-if='!HM.is_mobile')
      .message-body
        .columns
          .column(style='align-self: center;')
            p
              | {{ $t('not_confirmed_transactions', [$store.getters.transactions_past_not_entered.length]) }}
              br
              small {{ $t('Confirm or delete them') }}
          .column.is-narrow(style='align-self: center;')
            a.button.is-info(@click='viewPastNotEntered()') {{ $t('View transactions »') }}

  .box(style='padding: 0 1.25rem')
    .columns(style='margin-top: 0')
      .column.is-narrow(style='padding: 0; align-self: center;')
        date_changer(:mode='mode')
      .column.has-text-centered(style='align-self: center;')
        a.button.is-default.is-small(@click="openCategoriesStats()" v-if="stats_visible != 'categories' && filtered_trs.length > 0" title='ALT + Z')
          span.icon.is-small: v-icon(name='chart-pie')
          span {{ $t('Breakdown') }}
        a.button.is-default.is-small(@click="stats_visible = null" v-if="stats_visible == 'categories'" title='ALT + Z')
          span {{ $t('Hide') }}
        | &nbsp;
        a.button.is-default.is-small#new_transaction_button(@click='newTransaction()' v-if='$store.state.ui.online && !HM.is_mobile')
          span.icon.is-small: v-icon(name='plus')
          span {{ $t('New Transaction') }}

      .column.is-narrow(style='align-self: center; padding: 0')
        totals_stats(:transactions="filtered_trs")

  .box(v-if="stats_visible == 'categories' && !HM.is_mobile"): categories_stats(:transactions="filtered_trs", @hide="stats_visible = null")

  //- Mobile Categories Stats
  .modal.animated.faster.fadeIn(v-if="HM.is_mobile && stats_visible == 'categories'", :class="{'is-active': stats_visible == 'categories'}")
    .modal-background(@click="stats_visible = null")
    .modal-card
      header.modal-card-head(@click='stats_visible = null')
        p.modal-card-title {{ $t('Breakdown') }}
        a.delete
      section.modal-card-body: categories_stats(:transactions="filtered_trs", @hide="stats_visible = null")

  keep-alive: router-view


</template>

<script>
import 'vue-awesome/icons/chart-pie'
import 'vue-awesome/icons/plus'

export default {
  name: 'transactions',
  components: {
    date_changer:                () => import(/* webpackChunkName: "date_changer" */'./calendar/date_changer.vue'),
    totals_stats:                () => import(/* webpackChunkName: "totals_stats" */'./calendar/totals_stats.vue'),
    categories_stats:            () => import(/* webpackChunkName: "categories_stats" */'./transactions/categories_stats.vue')
  },
  data() {
    return {stats_visible: null};
  },
  computed: {
    has_transaction() { return !_.isEmpty(this.$store.state.ui.transactions.current.transaction); },
    filtered_trs() { return this.$store.state.ui.transactions[this.mode].filtered_trs; },
    all_trs() { return this.$store.state.ui.transactions[this.mode].all_trs; },
    mode: {
      get() {  if (this.$route.name.includes('list')) { return 'list'; } else { return 'calendar'; } },
      set(tab_name) {
        if (this.$route.name !== tab_name) { return this.$router.push({ name: tab_name }); }
      }
    }
  },
  mounted() {
    const event = "keyup.show_breakdown";
    return $(window).off(event).on(event, e => {
      if ((e.keyCode === 90) && (e.altKey === true)) {
        if ($('textarea:focus').length > 0) { return; }
        if ($('input:focus').length > 0) { return; }
        if (this.stats_visible === 'categories') {
          return this.stats_visible = null;
        } else {
          return this.openCategoriesStats();
        }
      }
    });
  },

  methods: {
    newTransaction(event, attrs) {
      if (attrs == null) { attrs = {}; }
      this.$nextTick(() => {
        this.$store.dispatch('initTransaction', attrs).then(new_transaction => {
          this.$store.dispatch('selectTransaction', new_transaction).then(() => {
            let f = function() {
              window.scroll(0, $("#current_transaction_popover").offset().top - 50)
            }
            !HM.is_mobile && this.$nextTick(function() { setTimeout(f, 40) })
          })
        });
      });
    },
    viewPastNotEntered() {
      this.$store.commit('TRANSACTIONS/LIST/RESET_FILTER');
      this.$store.commit('TRANSACTIONS/LIST/SET_FILTER', { type: 'not_entered' });
      const start = _.last(this.$store.getters.transactions_past_not_entered).date;
      const end   = hm_date.endOfMonth_f(hm_date.addMonths(new Date, -1));
      let route_name = HM.is_mobile ? 'mobile_list' : 'list'
      this.$router.push({ name: route_name, query: { dates: `${start}--${end}` } });
      return HM.track("transaction-view_past_not_entered");
    },
    openCategoriesStats() {
      this.stats_visible = 'categories';
      return this.$store.dispatch('hideTransactionsPopovers');
    }
  }
};
</script>

<i18n>
ru:
  'Breakdown': 'Статистика'
  'not_confirmed_transactions': 'Неподтвержденные транзакции с прошлых месяцев: {0}'
  'Confirm or delete them': 'Подтвердите их или удалите'
  'View transactions »': 'Показать транзакции »'
  Hide: 'Скрыть'
  'New Transaction': 'Новая транзакция'
  past_unconfirmed: 'Старые неподтверждённые транзакции »'
en:
  'not_confirmed_transactions': 'Unconfirmed transactions from previous months: {0}'
  past_unconfirmed: 'Past unconfirmed transactions »'
</i18n>
